import $x from '@/utils/$x';

/**
 * 查询拦截名单
 * @param {object} params - { requestData: { listType: 'GRAYLIST' | 'BLACKLIST' }, page: { currentPage, pageSize } }
 */
export async function queryBlocklist(params) {
  return $x.post('/user/vitality/blocklist/query', params);
}

/**
 * 新增拦截名单
 * @param {object} params - { requestData: { userId, listType, reason } }
 */
export async function addBlocklist(params) {
  return $x.post('/user/vitality/blocklist/add', params);
}

/**
 * 移除拦截名单
 * @param {object} params - { requestData: { userId, listType, reason } }
 */
export async function removeBlocklist(params) {
  return $x.post('/user/vitality/blocklist/remove', params);
}

// ==================== 运营监控大盘 ====================

/**
 * 总体统计概览 — 全国维度整体运营数据 + 近30日趋势
 */
export async function overallStats(params) {
  return $x.post('/v1/litta/vitality/go/dashboard/overallStats', {
    requestData: params || {},
  });
}

/**
 * 区域维度统计 — 根据 province/city/district 返回区域汇总 + 趋势
 * district 级别额外返回 stores 数组
 */
export async function regionStats(params) {
  return $x.post('/v1/litta/vitality/go/dashboard/regionStats', {
    requestData: params || {},
  });
}

/**
 * 排名统计 — 省/市/区三级排名
 */
export async function ranking(params) {
  return $x.post('/v1/litta/vitality/go/dashboard/ranking', {
    requestData: params || {},
  });
}

/**
 * 门店维度统计 — 指定门店或按区域汇总门店运营数据 + 近30日趋势
 */
export async function storeStats(params) {
  return $x.post('/v1/litta/vitality/go/dashboard/storeStats', {
    requestData: params || {},
  });
}
